import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xp76rbjked: FaireBrandEntity = {
  token: "b_xp76rbjked",
  type: "brand",
  name: "Holland Ave Clothing",
  avatarUrl:
    "https://cdn.faire.com/fastly/c7d6e059f87e1f570b39f785e3e8d0c0a1032fa10eeae4ff8c81f362eb9f49ef.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7bb53a56e660a66ebcc7e4e5c457cf68e80adc323adc6e237a9d19d376ed7fd0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c7d6e059f87e1f570b39f785e3e8d0c0a1032fa10eeae4ff8c81f362eb9f49ef.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7bb53a56e660a66ebcc7e4e5c457cf68e80adc323adc6e237a9d19d376ed7fd0.png",
  location: "Grain Valley, MO, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 89,
  isTopShop: true,
  isInsider: true,
  description: "Everyday Apparel for the Trendy Toddler\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:43.507Z",
    importedBy: "entity-db-cli",
  },
};
